import styled from '@emotion/styled';
import { Button } from 'antd';

export const DisabledButton = styled(Button)`
  :disabled {
    background-color: #fdba74;
    color: #ffffff;
    border: none;
  }
`;
